var React = require('react');

function HalfFireIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M236.361 0H235.165C295.186 132.194 0 258.454 0 454.799C0 582.839 92.7232 689.385 215.224 712C102.361 618.574 94.9167 484.205 231.974 306.65C223.466 349.242 218.082 453.283 246.93 518.687C267.535 565.433 303.428 586.004 325.827 574.334C329.217 572.554 332.341 570.048 335 566.752V496.007C334.269 494.226 333.538 492.38 332.607 490.534C333.405 490.864 334.202 491.128 335 491.457V75.4262C310.008 44.5041 275.046 19.9115 236.361 0Z","fill":"black","fillOpacity":"0.5"}));
}

HalfFireIcon.defaultProps = {"width":"334","height":"712","viewBox":"0 0 334 712","fill":"none"};

module.exports = HalfFireIcon;

HalfFireIcon.default = HalfFireIcon;
